import type { Technique } from '../types';
import { GAME_OF_LIFE_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type GameOfLifeState } from './render';

export const gameOfLife: Technique<GameOfLifeState> = {
  id: 'game-of-life',
  name: 'Zelluläre Automaten',
  category: 'automata',
  description: 'Conway und Verwandte, mit dem Text als Startzustand, Sperrzone oder festen Zellen.',
  params: GAME_OF_LIFE_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
